import { log } from "@lululemon/mwa-utils";
import { getAllSizes, getSkusFromWishlists } from "../../utils/helpers";
import { WISHLIST_HEART_KEY } from "../../utils/constants";
import fetchProductDetails from "../../graphql/fetchProductDetails";

export const addSkuToWishlist = ({
  allSkus,
  swatches,
  setSizes,
  prepareToAddToWishlist,
  wishlists,
  sizes,
}) => {
  let allSizes = sizes;
  if (!allSizes) {
    allSizes = getAllSizes(allSkus, swatches);
    setSizes(allSizes);
  }

  allSizes?.length > 1
    ? setShowSizeSelector(true)
    : prepareToAddToWishlist({
        wishlists,
        selectedSize: allSizes?.[0],
        skus: allSkus,
      });
};

export const retrieveSizesAndAddToWishlist = async ({
  skuCache,
  productId,
  swatches,
  setSizes,
  setShowSizeSelector,
  prepareToAddToWishlist,
  wishlists,
  setShowSpinner,
  product,
  graphqlClient,
  dispatch,
  color,
  unifiedId,
  categoryUnifiedId,
  setSizeGuide,
  locale,
}) => {
  if (Object.keys(skuCache).includes(productId)) {
    // getting sizes from cache
    addSkuToWishlist({
      allSkus: skuCache[productId],
      swatches,
      setSizes,
      setShowSizeSelector,
      prepareToAddToWishlist,
      wishlists,
    });
  } else {
    // getting skus from api and start add to wishlist flow
    setShowSpinner(true);
    const { skus: productSkus } = await getProductDetails({
      product,
      productId,
      graphqlClient,
      dispatch,
      color,
      unifiedId,
      category: categoryUnifiedId,
      setSizeGuide,
      locale,
    });

    addSkuToWishlist({
      allSkus: productSkus,
      swatches,
      setSizes,
      setShowSizeSelector,
      prepareToAddToWishlist,
      wishlists,
    });
    setShowSpinner(false);
  }
};

// get skus and size guide in a single request
export const getProductDetails = async ({
  product,
  productId,
  graphqlClient,
  dispatch,
  color,
  unifiedId,
  category,
  setSizeGuide,
  locale,
}) => {
  try {
    const result = await fetchProductDetails({
      color,
      productId,
      unifiedId,
      category,
      graphqlClient,
      dispatch,
      locale: locale?.toLowerCase()?.replace("_", "-"),
    });
    if (result?.sizeGuide) {
      setSizeGuide(result.sizeGuide);
    }

    return result;
  } catch (error) {
    log.error(WISHLIST_HEART_KEY, error);
    const normalizedSkus = product?.["sku-style-order"]?.map((s) => {
      return {
        id: s?.sku?.split("_")?.pop(),
        size: s?.size,
        color: {
          code: s?.["color-id"],
          name: s?.["color-name"],
        },
      };
    });
    return { skus: normalizedSkus };
  }
};

export const prepareToRemoveFromWishlists = ({
  productId,
  wishlists,
  swatches,
  selectedSwatchIndex,
  setSkusToDelete,
  removeSkus,
}) => {
  const skus = getSkusFromWishlists({
    productId,
    wishlists,
    color: swatches?.[selectedSwatchIndex]?.id,
  });

  setSkusToDelete(skus);

  removeSkus(skus);
};

export const addStyleOptionToWishlist = async ({
  sendAnalyticsEvent = () => {},
  productStyles = [],
  addToWishlist = () => {},
  productId = "",
  product = {},
  color = "",
  countryCode = "",
}) => {
  try {
    const styleIds = productStyles?.find(
      (style) => style?.["color-id"] === color
    );
    const styleOptionId = styleIds?.["style-id"];
    const styleId1 = styleIds?.["style-id-01"];
    const styleId2 = styleIds?.["style-id-02"];
    const listPrice = product?.["list-price"]?.[0] || "";
    const salePrice = product?.["product-sale-price"]?.[0] || "";
    const onSale = product?.["product-on-sale"];
    if (!styleOptionId) {
      throw new Error("unable to find style-id for the given color");
    }
    const componentId = "list-add";
    sendAnalyticsEvent({
      componentId,
      skuList: [
        {
          attributes: {
            styleId1,
            styleId2,
          },
          price: {
            onSale,
            displaySale: salePrice,
            displayRegular: listPrice,
          },
          sku: "",
          size: "",
        },
      ],
    });

    return addToWishlist({
      wishlistId: "default",
      id: styleOptionId,
      wishlistItemDetails: {
        styleOption: styleOptionId,
        styleNumber: styleId1,
        productId,
        color,
        type: "styleOption",
        countryCode,
      },
    });
  } catch (error) {
    log.error(WISHLIST_HEART_KEY, error);
    return false;
  }
};
